// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__nPqw6","main":"Layout_main__FOeMr","content":"Layout_content__ynjLW"};